<template>
  <div class="come-back-to-admin__container">
    <el-button
      v-if="isMobile && isAdminToken()"
      class="come-back-to-admin__container--button"
      size="mini"
      type="danger"
      @click="handleClickBtn"
    >
      Вернуться к админу
    </el-button>
  </div>
</template>

<script>
import { CHANGE_PROFILE } from '@/store/actions/userprofile'

export default {
  name: 'ComeBackToAdmin',
  data() {
    return {
      userData: {},
    }
  },
  created() {
    this.userData = {
      token: {
        token: localStorage.getItem('admin-token'),
      },
      user_type: 1,
    }
  },
  methods: {
    handleClickBtn() {
      this.$store.dispatch(`userProfile/${CHANGE_PROFILE}`, this.userData)
    },
    isAdminToken() {
      return Boolean(this.userData.token.token)
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.come-back-to-admin
  &__container
    text-align: center
    position: fixed
    top: 5rem
    right: 2rem
    z-index: 100000
</style>
